import React from 'react';
import { Box, Typography } from '@mui/material';
import tagEmptyStateImg from 'images/tag_library_empty.png'; // Import the image directly

const TagsEmptyState = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '95%',
        display: 'flex',
        position: 'relative',
        alignItems: 'center',
        borderRadius: '12px',
        flexDirection: 'column',
        paddingBottom: '50px',
        justifyContent: 'center',
        backgroundColor: '#F2F2F2'
      }}
    >
      <img
        src={tagEmptyStateImg}
        alt="tagEmptyState"
        style={{
          width: '60%',
          objectFit: 'contain'
        }}
        className="jss164"
      />
      
      <Typography
        variant="body1"
        sx={{
          margin: '5px 0px',
          fontWeight: 600,
        }}
        className="jss162"
      >
        No Tags
      </Typography>
    </Box>
  );
};

export default TagsEmptyState;